import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import styled from 'styled-components';

const Container = styled.div`
  .modal-dialog {
    width: 80%;
  }
`;

const Discord = styled.div`
  position: 'relative';
  overflow: 'hidden';
  padding-top: '30%';
  width: 100%;
  height: '65vh';
`;

/* Then style the iframe to fit in the container div with full height and width */
const ResponsiveIframe = styled.iframe`
  position: 'absolute';
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 80vh;
`;

const Content = props =>
  <Discord>
    <ResponsiveIframe src="https://titanembeds.com/embed/621450475669291050" frameBorder="0"></ResponsiveIframe>
  </Discord>

const DiscordModal = (props) => {
  return (
    props.show
    ? <Container className="static-modal">
         <Modal.Dialog>
           <Modal.Body>
             <Content {...props}/>
             <Button onClick={ () => { props.hide() } }>Close</Button>
           </Modal.Body>
         </Modal.Dialog>
      </Container>
      : <div></div>
  )
}

export default DiscordModal;
